import { render, staticRenderFns } from "./candidate_age_civil_state.vue?vue&type=template&id=1461cbf0&scoped=true&"
import script from "./candidate_age_civil_state.vue?vue&type=script&lang=js&"
export * from "./candidate_age_civil_state.vue?vue&type=script&lang=js&"
import style0 from "./candidate_age_civil_state.vue?vue&type=style&index=0&id=1461cbf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1461cbf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1461cbf0')) {
      api.createRecord('1461cbf0', component.options)
    } else {
      api.reload('1461cbf0', component.options)
    }
    module.hot.accept("./candidate_age_civil_state.vue?vue&type=template&id=1461cbf0&scoped=true&", function () {
      api.rerender('1461cbf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/metrics/candidate_age_civil_state.vue"
export default component.exports